import { render, staticRenderFns } from "./phone-today.vue?vue&type=template&id=bc81b2c6&scoped=true"
import script from "./phone-today.vue?vue&type=script&lang=js"
export * from "./phone-today.vue?vue&type=script&lang=js"
import style0 from "./phone-today.vue?vue&type=style&index=0&id=bc81b2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc81b2c6",
  null
  
)

export default component.exports